<template>
  <div
    class="w-full shadow md:w-56 p-4 h-[80px] fixed bottom-0 flex items-center justify-between bg-white md:shadow-2xl shadow-indigo-500/40 z-10 bottom-0"
  >
    <div class="md:w-1/3">
      <button
        @click="handleUpdate"
        class="w-10 h-10 flex items-center justify-center rounded-full shadow bg-blueGray-300 text-sm"
      >
        <IconSync class="w-5 h-5" :class="update && 'animate-spin'" />
      </button>
    </div>
    <div class="w-2/3">
      <p class="text-xs">last update:</p>
      <p class="text-xs">
        {{ updateTime || "unknown" }}
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import * as Helpers from "@/helpers";
import IconSync from "@/assets/icons/IconSync";

export default {
  name: "HardRefreshBtn",
  components: {
    IconSync
  },
  data() {
    return { update: false, updateTime: "unknown" };
  },
  mounted() {
    if (localStorage.getItem(`abi_${this.getRegion}_refresh_time_stamp`)) {
      this.updateTime = this.timeFormatter(
        localStorage.getItem(`abi_${this.getRegion}_refresh_time_stamp`)
      );
    }
  },
  computed: {
    ...mapGetters(["getRegion"])
  },
  methods: {
    async handleUpdate() {
      this.update = true;
      await Helpers.loadAllRelatedData(this, {
        hardRefresh: true,
        region: this.getRegion
      });
      this.update = false;
      this.updateTime = this.timeFormatter(
        localStorage.getItem(`abi_${this.getRegion}_refresh_time_stamp`)
      );
    },
    timeFormatter(data) {
      let time = new Date(JSON.parse(data).timestamp);
      var months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ];
      let hours = time.getHours();
      let minutes = time.getMinutes();
      let seconds = time.getSeconds();
      let date = time.getDate();
      let year = time.getFullYear();
      let month = months[time.getMonth()];
      let formattedTime =
        date +
        " " +
        month +
        " " +
        year +
        " " +
        hours +
        ":" +
        minutes +
        ":" +
        seconds;
      return formattedTime;
    }
  }
};
</script>
